import "leaflet-image-transform/dist/L.ImageOverlay.Transform.min.js";
import { useEffect, useRef,useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';


const ImageTransformECRG = ({ data, activeOverlay, layer1, layer, setLoading, count }) => {
  const map = useMap(); // Get access to the Leaflet map instance
  let transformedImages = []; // Array to store references to overlays for cleanup
 const countRef = useRef(0);

  useEffect(() => {

      const opacity = parseFloat(localStorage.getItem('opacity'))
      
    setTimeout(() => {
      console.log('ok')
    }, 1000); 

      
    if (!data || !Array.isArray(data)) return; // Safety check

    const filtered_data = data.filter(item => item.id === '11311271' || item.id_code.toLowerCase() === 'ecrg');
    filtered_data.forEach((tiles) => {
        console.log(tiles.id)
      const imageUrl = `/storage/new/${tiles.region}/${tiles.name}.png`;
      const parsedCoordinates = JSON.parse(tiles.coordinates_4326); 
      
      const coordinates = parsedCoordinates[0].map(coord => [coord[1], coord[0]]);
      const imageCorners = [
        coordinates[0], // Top-Left
        coordinates[1], // Top-Right
        coordinates[2], // Bottom-Right
        coordinates[3], // Bottom-Left
      ];

      if (imageUrl && imageCorners.length === 4) {
        const transformedImage = L.imageOverlay.transform(imageUrl, imageCorners, {
          editable: false,
          interactive: false,
          scalable: false,
          draggable: false,
          rotatable: false,
         fit: true,
         opacity: opacity
        });

         

        // Conditional rendering logic
        if (activeOverlay === "dataset-2" && layer.toLowerCase() !== "none") {
          transformedImage.addTo(map);
            
          transformedImages.push(transformedImage); // Store for cleanup
          
       
          const element = transformedImage.getElement();    
        
          
            
          if (element) {
            element.style.border = 'none';
            element.style.outline = 'none';
            element.style.boxShadow = 'none';


            
          }


            
            
        }
      }
    });
      

    // Cleanup function to remove overlays when dependencies change
    return () => {
      transformedImages.forEach(image => {
        if (map.hasLayer(image)) {
          map.removeLayer(image);
        }
      });
    };
      
  }, [map, data, activeOverlay, layer1, layer, setLoading, localStorage.getItem('opacity')]); // Dependencies // Mark loading as done

     useEffect(() => {
    if (transformedImages[data.length - 1]) {
        const img = transformedImages[data.length - 1]._rawImage;

        if (img) {
             img.onload = null
            if (img.complete) {
                // Image already loaded (possibly cached)
                console.log('✅ Image already loaded (cached).');
                setLoading(false);
            } else {
                // Image is loading
                setLoading(true);
                img.onload = () => {
                    console.log('✅ Image finished loading.');
                    setLoading(false);
                };
            }
        }
    }
}, [transformedImages, data, setLoading]);

   
    

  return null; // This component renders nothing directly
};
export default ImageTransformECRG;
